import Dashboard from "layouts/dashboard";
import FollowUps from "layouts/followUps";
import OPDAppointments from "layouts/opdAppointments";

// Pharmacy
import MMDashboard from "layouts/pharmacy/mm";
import PharmItemDetail from "layouts/pharmacy/mm/items/ItemDetail";
import InwardList from "layouts/pharmacy/inward";
import InwardForm from "layouts/pharmacy/inward/InwardForm";
import InventoryDashboard from "layouts/pharmacy/inventory";
import PharmaciesScreen from "layouts/pharmacy/pharmacies";
import LocationsScreen from "layouts/pharmacy/locations";
import BillingList from "layouts/pharmacy/billing";
import BillingForm from "layouts/pharmacy/billing/BillingForm";
import CreditNotesPage from "layouts/pharmacy/billing/CreditNotesPage";
import DebitNotesPage from "layouts/pharmacy/billing/DebitNotesPage";
import PharmacyPaymentsPage from "layouts/pharmacy/billing/PaymentsPage";
import ReturnsPage from "layouts/pharmacy/billing/ReturnsPage";
import GuestPatientsPage from "layouts/pharmacy/billing/GuestPatientsPage";
import JournalLedgerPage from "layouts/pharmacy/billing/JournalLedgerPage";
import OpdBilling from "layouts/opdBilling";
import OpdBillDetail from "layouts/opdBilling/BillDetail";
import OpdFeeConfig from "layouts/opdBilling/FeeConfig";

// Accounts (cross-department — Pharmacy + OPD)
import AccountsPaymentsPage from "layouts/accounts/PaymentsPage";
import AccountsDocumentsPage from "layouts/accounts/DocumentsPage";

import SignIn from "layouts/authentication/sign-in";
import SignOut from "layouts/authentication/sign-out";

// @mui icons
import Icon from "@mui/material/Icon";
import PatientRegistration from "layouts/patientRegistration";
import PatientList from "layouts/patientList";
import AuditLog from "layouts/auditLog";
import PatientDetails from "layouts/patientDetails";
import PatientEdit from "layouts/patientEdit";
import ContactHistories from "layouts/contactHistories";
import PatientInvestigations from "layouts/patientInvestigations";
import PatientDocuments from "layouts/patientDocuments";
import CreateDraftPrescription from "layouts/prescription";
import PrescriptionList from "layouts/prescriptionList";
import PatientPrescriptionSearch from "layouts/prescriptionList/PatientPrescriptionSearch";
import ManagePrescription from "layouts/managePrescription";
import PrescriptionView from "layouts/prescriptionView";
import InfertilitySummary from "layouts/infertilitySummary";
import UserRegistration from "layouts/userRegistration";
import UsersList from "layouts/usersList";
import RoleManagement from "layouts/roleManagement";
import MyProfile from "layouts/myProfile";
import IVFProcedures from "layouts/ivfProcedures";
import ProcedureInitiation from "layouts/procedureInitiation";
import IVFFolliculometry from "layouts/ivfFolliculometry";
import IVFLabPerformance from "layouts/ivfLabPerformance";
import SMS from "layouts/sms";
import DonorRegistration from "layouts/donorRegistration";
import DonorList from "layouts/donorList";
import DonorDetails from "layouts/donorDetails";
import DonorEdit from "layouts/donorEdit";
import DonorInvestigations from "layouts/donorInvestigations";
import DonorContactHistories from "layouts/donorContactHistories";
import OldPatientRegistration from "layouts/oldPatientRegistration";

const routes = [
  {
    type: 'collapse',
    name: 'Dashboard',
    key: 'dashboard',
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: '/dashboard',
    component: <Dashboard />,
  },
  {
    type: 'collapse',
    name: 'Patient Registration',
    key: 'patient-registration',
    icon: <Icon fontSize="small">person_add</Icon>,
    route: '/patient-registration',
    component: <PatientRegistration />,
  },
  {
    type: 'collapse',
    name: 'Old Patient Registration',
    key: 'old-patient-registration',
    icon: <Icon fontSize="small">history</Icon>,
    route: '/old-patient-registration',
    component: <OldPatientRegistration />,
  },
  {
    type: "collapse",
    name: "Patient List",
    key: "patient-list",
    icon: <Icon fontSize="small">list</Icon>,
    route: "/patient-list",
    component: <PatientList />,
  },
  {
    type: "collapse",
    name: "Audit Log",
    key: "audit-log",
    icon: <Icon fontSize="small">history_edu</Icon>,
    route: "/audit-log",
    component: <AuditLog />,
    requiredPermission: "v1-contact-audit-logs",
  },
  {
    type: "hidden",
    name: "Patient Audit Log",
    key: "patient-audit-log",
    route: "/audit-log/:patientCode",
    component: <AuditLog />,
  },
  {
    type: "collapse",
    name: "Donor Registration",
    key: "donor-registration",
    icon: <Icon fontSize="small">volunteer_activism</Icon>,
    route: "/donor-registration",
    component: <DonorRegistration />,
  },
  {
    type: "collapse",
    name: "Donor List",
    key: "donor-list",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/donor-list",
    component: <DonorList />,
  },
  {
    type: "hidden",
    name: "Donor Details",
    key: "donor-details",
    route: "/donor-details/:external_code",
    component: <DonorDetails />,
  },
  {
    type: "hidden",
    name: "Donor Edit",
    key: "donor-edit",
    route: "/donor-edit/:external_code",
    component: <DonorEdit />,
  },
  {
    type: "hidden",
    name: "Donor Investigations",
    key: "donor-investigations",
    route: "/donor-investigations/:donorCode",
    component: <DonorInvestigations />,
  },
  {
    type: "hidden",
    name: "Donor Contact Histories",
    key: "donor-contact-histories",
    route: "/donor-contact-histories/:donorCode",
    component: <DonorContactHistories />,
  },
  {
    type: '',
    name: 'User Registration',
    key: 'user-registration',
    icon: <Icon fontSize="small">person_add</Icon>,
    route: '/user-registration',
    component: <UserRegistration />,
    superAdminOnly: true,
  },
  {
    type: 'collapse',
    name: 'Users List',
    key: 'users-list',
    icon: <Icon fontSize="small">group</Icon>,
    route: '/users-list',
    component: <UsersList />,
    superAdminOnly: true,
  },
  {
    type: 'collapse',
    name: 'Role Management',
    key: 'role-management',
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    route: '/role-management',
    component: <RoleManagement />,
    superAdminOnly: true,
  },
  {
    type: "hidden",
    name: "Patient Details",
    key: "patient-details",
    route: "/patient-details/:patient_code/:couple_code",
    component: <PatientDetails />,
  },
  {
    type: "hidden",
    name: "Patient Edit",
    key: "patient-edit",
    route: "/patient-edit/:patient_code/:couple_code",
    component: <PatientEdit />,
  },
  {
    type: "hidden",
    name: "Contact Histories",
    key: "contact-histories",
    route: "/contact-histories/:patient_code/:couple_code",
    component: <ContactHistories />,
  },
  {
    type: "hidden",
    name: "Patient Investigations",
    key: "patient-investigations",
    route: "/contact-investigations/:patientCode/:coupleCode",
    component: <PatientInvestigations />,
  },
  {
    type: "hidden",
    name: "Patient Documents",
    key: "patient-documents",
    route: "/patient-documents/:patientCode/:coupleCode",
    component: <PatientDocuments />,
  },
  {
    type: "hidden",
    name: "Prescription List",
    key: "prescription-list",
    icon: <Icon fontSize="small">list_alt</Icon>,
    route: "/prescription/search",
    component: <PrescriptionList />,
  },
  {
    type: "hidden",
    name: "Create Draft Prescription",
    key: "create-draft-prescription",
    route: "/prescription/create/draft/:patientCode/:coupleCode",
    component: <CreateDraftPrescription />,
  },
  {
    type: "hidden",
    name: "Patient Prescription Search",
    key: "patient-prescription-search",
    route: "/prescription/patient/:patientCode/:coupleCode",
    component: <PatientPrescriptionSearch />,
  },
  {
    type: "hidden",
    name: "Manage Prescription",
    key: "manage-prescription",
    route: "/prescription/manage/:patientCode/:coupleCode/:prescriptionCode",
    component: <ManagePrescription />,
  },
  {
    type: "hidden",
    name: "Prescription View",
    key: "prescription-view",
    route: "/prescription/view/:patientCode/:coupleCode/:prescriptionCode",
    component: <PrescriptionView />,
  },
  {
    type: "collapse",
    name: "Follow Ups",
    key: "follow-ups",
    icon: <Icon fontSize="small">event_note</Icon>,
    route: "/follow-ups",
    component: <FollowUps />,
  },
  {
    type: "collapse",
    name: "OPD Appointments",
    key: "opd-appointments",
    icon: <Icon fontSize="small">event_available</Icon>,
    route: "/opd-appointments",
    component: <OPDAppointments />,
    requiredPermission: "v1-opd-appointment-list",
  },
  {
    type: "collapse",
    name: "IVF",
    key: "ivf",
    icon: <Icon fontSize="small">science</Icon>,
    route: "/ivf",
    component: <IVFProcedures />,
  },
  {
    type: "collapse",
    name: "SMS",
    key: "sms",
    icon: <Icon fontSize="small">sms</Icon>,
    route: "/sms",
    component: <SMS />,
  },
  {
    type: "hidden",
    name: "Infertility Summary",
    key: "infertility-summary",
    route: "/infertility-summary/:patientCode/:coupleCode",
    component: <InfertilitySummary />,
  },
  {
    type: "hidden",
    name: "Procedure Initiation",
    key: "procedure-initiation",
    route: "/ivf/initiation/:procedureId",
    component: <ProcedureInitiation />,
  },
  {
    type: "hidden",
    name: "IVF Folliculometry",
    key: "ivf-folliculometry",
    route: "/ivf/folliculometry/:procedureId",
    component: <IVFFolliculometry />,
  },
  {
    type: "hidden",
    name: "IVF Lab",
    key: "ivf-lab-performance",
    route: "/ivf/lab-performance/:procedureId",
    component: <IVFLabPerformance />,
  },
  // {
  //   type: "collapse",
  //   name: "Tables",
  //   key: "tables",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/tables",
  //   component: <Tables />,
  // },
  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  //   component: <Billing />,
  // },
  // {
  //   type: "collapse",
  //   name: "RTL",
  //   key: "rtl",
  //   icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
  //   route: "/rtl",
  //   component: <RTL />,
  // },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: <Profile />,
  // },
  {
    // type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: '/authentication/sign-in',
    component: <SignIn />,
  },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   icon: <Icon fontSize="small">assignment</Icon>,
  //   route: "/authentication/sign-up",
  //   component: <SignUp />,
  // },
  {
    type: 'collapse',
    name: 'My Profile',
    key: 'my-profile',
    icon: <Icon fontSize="small">person</Icon>,
    route: '/my-profile',
    component: <MyProfile />,
  },
  {
    type: "collapse",
    name: "Sign Out",
    key: "sign-out",
    icon: <Icon fontSize="small">logout</Icon>,
    route: "/authentication/sign-out",
    component: <SignOut />,
  },

  // ── Pharmacy ─────────────────────────────────────────────
  {
    type: "divider",
    key: "divider-pharmacy",
  },
  {
    type: "title",
    title: "Pharmacy",
    key: "pharmacy-title",
  },
  {
    type: "collapse",
    name: "Material Management",
    key: "pharmacy/mm",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/pharmacy/mm",
    component: <MMDashboard />,
  },
  {
    type: "hidden",
    name: "Item Detail",
    key: "pharm-mm-item-detail",
    route: "/pharmacy/mm/items/:itemId",
    component: <PharmItemDetail />,
  },
  {
    type: "collapse",
    name: "Inward / GRN",
    key: "pharmacy/inward",
    icon: <Icon fontSize="small">local_shipping</Icon>,
    route: "/pharmacy/inward",
    component: <InwardList />,
  },
  {
    type: "hidden",
    name: "New GRN",
    key: "pharmacy-inward-new",
    route: "/pharmacy/inward/new",
    component: <InwardForm />,
  },
  {
    type: "hidden",
    name: "GRN Detail",
    key: "pharmacy-inward-detail",
    route: "/pharmacy/inward/:id",
    component: <InwardForm />,
  },
  {
    type: "collapse",
    name: "Inventory",
    key: "pharmacy/inventory",
    icon: <Icon fontSize="small">warehouse</Icon>,
    route: "/pharmacy/inventory",
    component: <InventoryDashboard />,
  },
  {
    type: "collapse",
    name: "Billing / Outward",
    key: "pharmacy/billing",
    icon: <Icon fontSize="small">receipt</Icon>,
    route: "/pharmacy/billing",
    component: <BillingList />,
  },
  {
    type: "hidden",
    name: "Credit Notes",
    key: "pharmacy-billing-credit-notes",
    route: "/pharmacy/billing/credit-notes",
    component: <CreditNotesPage />,
  },
  {
    type: "hidden",
    name: "Debit Notes",
    key: "pharmacy-billing-debit-notes",
    route: "/pharmacy/billing/debit-notes",
    component: <DebitNotesPage />,
  },
  {
    // Relocated under Accounts (cross-department) — kept registered so any
    // existing bookmark/deep-link still resolves, but no longer a menu item
    // here since it only ever showed Pharmacy's own cash movements.
    type: "hidden",
    name: "Payments",
    key: "pharmacy-billing-payments",
    route: "/pharmacy/billing/payments",
    component: <PharmacyPaymentsPage />,
  },
  {
    // Relocated under Accounts — see note above. JournalLedgerPage itself is
    // unchanged and was already department-generic; only its menu placement
    // was Pharmacy-specific.
    type: "hidden",
    name: "Journal & Ledger",
    key: "pharmacy-billing-journal-ledger",
    route: "/pharmacy/billing/journal-ledger",
    component: <JournalLedgerPage />,
  },
  {
    type: "hidden",
    name: "Returns",
    key: "pharmacy-billing-returns",
    route: "/pharmacy/billing/returns",
    component: <ReturnsPage />,
  },
  {
    type: "hidden",
    name: "Guest Patients",
    key: "pharmacy-billing-guest-patients",
    route: "/pharmacy/billing/guest-patients",
    component: <GuestPatientsPage />,
  },
  {
    type: "hidden",
    name: "New Bill",
    key: "pharmacy-billing-new",
    route: "/pharmacy/billing/new",
    component: <BillingForm />,
  },
  {
    type: "hidden",
    name: "Bill Detail",
    key: "pharmacy-billing-detail",
    route: "/pharmacy/billing/:id",
    component: <BillingForm />,
  },
  {
    type: "collapse",
    name: "Pharmacies",
    key: "pharmacy/manage",
    icon: <Icon fontSize="small">local_pharmacy</Icon>,
    route: "/pharmacy/manage",
    component: <PharmaciesScreen />,
  },
  {
    type: "collapse",
    name: "Store Locations",
    key: "pharmacy/locations",
    icon: <Icon fontSize="small">storefront</Icon>,
    route: "/pharmacy/locations",
    component: <LocationsScreen />,
  },

  // ── OPD ──────────────────────────────────────────────────
  {
    type: "divider",
    key: "divider-opd-billing",
  },
  {
    type: "title",
    title: "OPD",
    key: "opd-billing-title",
  },
  {
    type: "collapse",
    name: "Consultation Billing",
    key: "opd/billing",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/opd/billing",
    component: <OpdBilling />,
    requiredPermission: "v1-opd-billing-view",
  },
  {
    type: "hidden",
    name: "OPD Fee Config",
    key: "opd-billing-fee-config",
    route: "/opd/billing/fee-config",
    component: <OpdFeeConfig />,
  },
  {
    type: "hidden",
    name: "OPD Bill Detail",
    key: "opd-billing-bill-detail",
    route: "/opd/billing/:billId",
    component: <OpdBillDetail />,
  },

  // ── Accounts (cross-department — Pharmacy + OPD, single source of truth) ──
  {
    type: "divider",
    key: "divider-accounts",
  },
  {
    type: "title",
    title: "Accounts",
    key: "accounts-title",
  },
  {
    type: "collapse",
    name: "Documents",
    key: "accounts/documents",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/accounts/documents",
    component: <AccountsDocumentsPage />,
  },
  {
    type: "collapse",
    name: "Payments",
    key: "accounts/payments",
    icon: <Icon fontSize="small">payments</Icon>,
    route: "/accounts/payments",
    component: <AccountsPaymentsPage />,
  },
  {
    type: "collapse",
    name: "Journal & Ledger",
    key: "accounts/journal-ledger",
    icon: <Icon fontSize="small">account_balance</Icon>,
    route: "/accounts/journal-ledger",
    component: <JournalLedgerPage />,
  },
];

export default routes;
